// extracted by mini-css-extract-plugin
export default {"statusInfoWrap":"Responses_statusInfoWrap__g5wMF"};